import { SelectHTMLAttributes } from "react";
import classNames from "classnames";
import { ChevronDownIcon } from "./icons";

/**
 * A native `<select>` with the platform arrow replaced by a drawn one.
 *
 * Native rather than a listbox of our own: on a phone this opens the system picker,
 * which is a far better way to choose between three search providers than anything
 * worth building here.
 *
 * 16px and 36px tall until the `md` breakpoint, then 11px and 28px. The small size is
 * what this wants in a footer bar, and it is also what makes mobile Safari zoom the
 * viewport when the field is tapped — so the compact version is only worn where no
 * browser does that. See the base rule in css/main.css.
 */
export function Select({
  className,
  children,
  ...rest
}: SelectHTMLAttributes<HTMLSelectElement>) {
  return (
    <div className={classNames("relative inline-flex items-center", className)}>
      <select
        className="h-9 w-full cursor-pointer appearance-none rounded-md border
          border-line-strong bg-surface-raised pr-6 pl-2 text-ink
          focus:border-accent focus:outline-1 focus:outline-accent
          md:h-7 md:text-micro"
        {...rest}
      >
        {children}
      </select>
      <ChevronDownIcon className="pointer-events-none absolute right-1.5 size-3.5 text-ink-faint" />
    </div>
  );
}
